<template>
    <div class="api-driven-list">
        <div class="list-label" v-if="listLabel != ''">{{listLabel}}</div>
        <div class="item-wrapper border border-radius">
                <div class="item" :class="{'selected-item': itemsEqualShallow(item, selectedItem)}"
                     ref="item"
                     v-for="(item, idx) in paginatedItems"
                     :key="idx"
                     @click="handleRowItemSelected(item)">
                    <div class="row-item" v-for="(column, cidx) in columns" :key="cidx">{{item[column]}}</div>
                </div>
            <div v-if="showLoading" class="loading-indicator"><span class="fa fa-cog fa-spin fa-1x"></span></div>
            <div v-if="showEmpty" class="loading-indicator">Empty</div>
        </div>
        <div class="modifiers">
            <list-filter placeholder="Filter" :targetList="items" :searchConfig="{targetKeys: columns}" @results="handleFilterResults"></list-filter>
            <list-paginator :mappingsPerPage="resultsPerPage" :targetList="filteredItems" @results="handlePaginationResults"></list-paginator>
        </div>
    </div>
</template>

<script>
import { TweenMax } from "gsap";
import ListFilter from '../generic/list-filter.vue';
import ListPaginator from '../generic/list-pagination.vue';

/*

PROPS
-----
list-label: The label to place above the list (default '')
items: Array of objects that will be presented to the user to select
columns: Array of keys from the object list above. Each key is a column output.
results-per-page: Number of items to display per results page (default 10)

EMITS
-----
selection: the item selected by the user

*/

export default {
    name: "select-item-from-provided-list",
    components: {
        'list-filter': ListFilter,
        'list-paginator': ListPaginator,
    },
    props: {
        listLabel: {
            value: String,
            default: ''
        },
        items: Array,
        columns: Array,
        resultsPerPage: {
            value: Number,
            default: 10,
        }
    },
    data() {
        return {
            filteredItems: this.items,
            paginatedItems: this.items,
            showLoading: false,
            selectedItem: {},
            showEmpty: false,
            activeQuery: false,
        };
    },
    methods: {
        handleFilterResults(value) {
            this.filteredItems = value;
        },
        handlePaginationResults(value) {
            this.paginatedItems = value;
        },
        itemsEqualShallow(a, b) {
            for(let key in a) {
                if(a[key] !== b[key]) {
                    return false;
                }
            }
            return true;
        },
        handleRowItemSelected(item) {
            this.selectedItem = item;
            this.$emit('selection', item);
        },
        handleResultsPerPageChage() {
            this.fadeItemsOut();
        },
        handleSearchChange: _.debounce(function (e) {
            this.handleSearch(e.target.value)
        }, 500),
        handleSearch(bounced) {
            this.query = bounced;
            this.current_page = 1;
            this.fadeItemsOut();
        },
        fadeItemsOut() {
            if (this.$refs.item) {
                TweenMax.staggerTo(this.$refs.item,0.2,{opacity:0}, 0.02, this.handleFadeOutComplete);
            }
        },
        fadeItemsIn() {
            if (this.$refs.item) {
                TweenMax.staggerTo(this.$refs.item,0.2,{opacity:1}, 0.02);
            }
        },
        handleNextNavigation() {
            if (!this.showLoading) {
                this.current_page ++;
                this.fadeItemsOut();
            }
        },
        handleFadeOutComplete(direction) {
            this.navigateTo(this.current_page);
        },
    }
};
</script>

<style lang="scss">
    .api-driven-list {
        margin-bottom: 20px;

        .item-wrapper {
            position: relative;
            min-height: 50px;
        }
        .list-label {
            margin: 10px 0;
            font-size: 17px;
        }
        .item {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 5px 15px;
            background-color: white;
            font-size: 15px;
            margin: 3px 0;
        }
        .item:hover {
            background-color: #dedede;
        }
        .selected-item {
            background-color:#1D4E7D;
            color: white;
            pointer-events: none;
        }
        .loading-indicator {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: white;
            display: flex;
            justify-content: center;
            align-items: center;
        }
        .modifiers {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            margin-top: 5px;
        }
        .list-form-element {
            font-family: "LatoWeb", sans-serif;
            z-index: 0;
            height: 35px;
            border: solid 1px #dedede;
            font-size: 13px;
            color: #333;
            padding: 0 5px;
        }
        select {
            margin-right: 5px
        }
        input {
            width: 200px;
        }
        .list-pagi-wrapper {
            display: flex;
            justify-content: flex-end;
        }
        .pagi {
            height: 35px;
            padding: 0;
            margin: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            user-select: none;
            border-width: 1px 0;
            border-style: solid;
            border-color: #CDD3E6;
            border-radius: 0;
            cursor: pointer;

            &.middle {
                min-width: 40px;
                border-left: 0;
                border-right: 1px;
                border-style: solid;
                border-color: #CDD3E6;
            }

            &.left {
                padding: 0 10px;
                border-left: 1px;
                border-right: 1px;
                border-top-left-radius: 4px;
                border-bottom-left-radius: 4px;
                border-style: solid;
                border-color: #CDD3E6;
                color: #1D4E7D;
            }

            &.right {
                padding: 0 10px;
                border-left: 0;
                border-right: 1px;
                border-top-right-radius: 4px;
                border-bottom-right-radius: 4px;
                border-style: solid;
                border-color: #CDD3E6;
                color: #1D4E7D;
            }

            &.disabled-pagi {
                color: #acb5d2;
                cursor: initial;
                pointer-events: none;
            }
        }
        .selected-pagi {
            background-color: #396095;
            border-color: #396095;
            color: white;
            pointer-events: none;
        }
        .pagi:hover {
            background-color: #E7E9F2;
        }
    }
</style>